.table {
  --mantine-datatable-border-color-dark: alpha(var(--mantine-color-dark-4), 0.5);
  --mantine-datatable-background-color-dark: transparent;
  height: 100%;
  /* display: grid; */
  /* grid-template: */
  /*   'filter' min-content */
  /*   'table' 1fr / 1fr; */
  /* gap: var(--mantine-spacing-sm); */
  /* anchor-name: --filterable-table; */
  /* anchor-scope: all; */
  max-height: clamp(20rem, 40cqmin, 40rem);
  overflow: auto;
  font-variation-settings: 'wdth' 97.5;
  font-variant-numeric: tabular-nums;
  :fullscreen & {
    max-height: unset;
  }

  thead {
    /* background: var(--mantine-color-dark-6); */
    background: alpha(var(--mantine-color-dark-6), 0.4);
    backdrop-filter: blur(var(--mantine-radius-sm));
  }
  tr {
    th:first-child {
      background: var(--mantine-color-dark-6);
    }
    td {
      background: var(--mantine-color-dark-8);
      &:first-child {
        background: var(--mantine-color-dark-7);
      }
    }
  }

  a {
    color: var(--mantine-color-white);
    text-decoration: none;
    border-bottom: 1px dashed var(--mantine-color-dark-3);
  }

  .caption {
    margin-bottom: var(--mantine-spacing-sm);
    font-weight: var(--mantine-heading-font-weight);
  }

  .numeric-value {
    text-align: right;
  }

  .na {
    color: var(--mantine-color-dark-3);
    text-align: center;
  }

  .unit {
    margin-left: calc(var(--mantine-spacing-md) * 0.4);
    font-weight: normal;
    color: var(--mantine-color-dark-1);
  }
}

.sorted-column {
  background: alpha(var(--mantine-color-dark-6), 0.5);
}

/* Adaptive layout: when the enclosing `TileFrame` shrinks, tighten cell
   padding and bump up density. Container-scoped (not viewport-scoped)
   so a narrow tile in a wide window adapts correctly. */
/* @container tile (inline-size < 480px) { */
/*   .table { */
/*     font-size: var(--mantine-font-size-xs); */
/*     th, */
/*     td { */
/*       padding-block: 0.25rem; */
/*       padding-inline: var(--mantine-spacing-2xs); */
/*     } */
/*   } */
/* } */
